import React, { useState, useEffect } from "react";
import { FadeLoader } from "react-spinners";
import {
  getProfileListing,
  getOccupations,
  getCities,
  getUserById,
} from "../utils/api";
import MatrimonyHeader from "../components/MatrimonyHeader";
import MatriProfileHero from "../components/MatriProfileHero";
import MatriOccupationUpload from "../components/MatriOccupationUpload";
import MatriRecentUpload from "../components/MatriRecentUpload";
import Footer from "../components/Footer";
import MatrimonySearch from "../components/MatrimonySearch";
import MatriHeader from "../components/MatriHeader";

export default function MatrimonyProfile() {
  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [hasFounder, setHasFounder] = useState(false);

  // Load user to determine founder status
  useEffect(() => {
    (async () => {
      const userId = localStorage.getItem("matrimonyUserId");
      if (!userId) return;
      try {
        const user = await getUserById(userId);
        setHasFounder(!!user.founder_id?.founderId);
      } catch (err) {
        console.error("Error loading user:", err);
      }
    })();
  }, []);

  // Load profiles once founder-status is known
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const data = await getProfileListing({});
        const list = hasFounder
          ? data
          : data.filter((p) => p.role === "entrepreneur");
        setProfiles(list);
        setFilteredProfiles(list);
      } catch (err) {
        console.error("Failed to load profiles:", err);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [hasFounder]);

  // Handle search, then apply the same filter
  const handleSearch = async (filters) => {
    setHasSearched(true);
    setLoading(true);
    try {
      let backend = await getProfileListing(filters);
      if (filters.occupation && backend.length === profiles.length) {
        backend = profiles.filter((p) => p.occupation === filters.occupation);
      }
      const results = hasFounder
        ? backend
        : backend.filter((p) => p.role === "entrepreneur");
      setFilteredProfiles(results);
    } catch (err) {
      console.error("Search API failed, falling back:", err);
      const fallback = profiles.filter((p) => p.occupation === filters.occupation);
      setFilteredProfiles(
        hasFounder ? fallback : fallback.filter((p) => p.role === "entrepreneur")
      );
    } finally {
      setLoading(false);
    }
  };

  // Show loading spinner while fetching
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <FadeLoader
          color="#E7603C"
          height={8}
          width={4}
          radius={2}
          margin={2}
          loading={true}
        />
      </div>
    );
  }

  return (
    <div>
      <MatriHeader />
      <MatriProfileHero />
      <MatrimonySearch onSearch={handleSearch} />
      <MatriRecentUpload
        profiles={filteredProfiles}
        loading={loading}
        hasSearched={hasSearched}
      />
      <MatriOccupationUpload />
      <Footer />
    </div>
  );
}
